import { Platform, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { ModalBottom } from '@ui/components/Modal'
import Button from '@ui/buttons/Button'
import Input from '@ui/forms/Input'
import { useStore } from 'hooks/useSession'
import { useLogoutStore } from 'hooks/useLogout'
import cn from '@ui/utils/cn'

interface Props {
  open: boolean
  close: () => void
}

const isWeb = Platform.OS === 'web'

export default function InfoStoreModal({ open, close }: Props) {
  const { t } = useTranslation(['modals', 'ui'])

  const text = 'modals:staff.info.store'

  const store = useStore()
  const logout = useLogoutStore()

  const { id, ref, name, region, prepay_method, address } = store || {}

  const labelWidth = isWeb ? 0 : undefined

  return (
    <ModalBottom
      open={open}
      close={close}
      title={t(`${text}.title`)}
      desc={t(`${text}.desc`)}
      body={
        <View className="gap-6 px-16">
          <View
            className={cn(
              'flex flex-row gap-6',
              isWeb ? 'flex-row' : 'flex-col'
            )}
          >
            <Input
              labelWidth={labelWidth}
              disabled
              label="ID"
              value={`${id}`}
              className="flex-1"
            />
            <Input
              labelWidth={labelWidth}
              disabled
              label="REF"
              value={`${ref}`}
              className="flex-1"
            />
            <Input
              labelWidth={labelWidth}
              disabled
              label="REGION"
              value={`${region}`}
              className="flex-1"
            />
          </View>

          <Input disabled label="NAME" value={`${name}`} />
          <Input
            disabled
            label="ADDRESS"
            value={`${address?.street || ''} ${address?.street2 || ''} ${
              address?.city || ''
            } ${address?.zip || ''} ${address?.country || ''}`}
          />
          <Input
            disabled
            label="PREPAY"
            value={
              prepay_method
                ? prepay_method.map(({ name }) => name).join(', ')
                : ''
            }
          />
        </View>
      }
      buttons={
        <View className="flex flex-row gap-8">
          <Button
            variant="filled"
            label={t('ui:close')}
            onPress={close}
            iconEnd="x"
          />
          <Button variant="outlined" label={t('ui:logout')} onPress={logout} />
        </View>
      }
    />
  )
}
